// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c9-b";
export var colorBlue = "_c9-8";
export var colorDot = "_c9-0";
export var colorDotLarge = "_c9-2";
export var colorDotSmall = "_c9-1";
export var colorGreen = "_c9-7";
export var colorGrey = "_c9-3";
export var colorOrange = "_c9-5";
export var colorPink = "_c9-a";
export var colorPurple = "_c9-9";
export var colorRed = "_c9-4";
export var colorYellow = "_c9-6";